import { Link } from 'react-router-dom';
import { services } from '../../mocks/services';

const HERO_IMAGE = 'https://greenworldil.com/wp-content/uploads/2025/06/Flat-Roofs-Chicago.webp';

const categories = [
  { key: 'roofing', label: 'Roofing Systems' },
  { key: 'masonry', label: 'Masonry & Tuckpointing' },
  { key: 'exterior', label: 'Exterior & Siding' },
];

export default function ServicesPage() {
  return (
    <main>
      {/* Hero */}
      <section
        className="relative flex items-end min-h-64 pt-40 pb-16"
        style={{ backgroundImage: `url('${HERO_IMAGE}')`, backgroundSize: 'cover', backgroundPosition: 'center top' }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-black/30" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
          <div className="inline-flex items-center gap-2 bg-brand-gold/20 border border-brand-gold/40 rounded-full px-4 py-1.5 mb-4">
            <i className="ri-home-4-line text-brand-gold text-xs" />
            <span className="text-brand-gold text-xs font-semibold uppercase tracking-widest">All Services</span>
          </div>
          <h1 className="font-display text-4xl lg:text-5xl font-bold text-white mb-3">
            Roofing &amp; Exterior Construction<br />
            <span className="text-brand-gold">Services in Chicago</span>
          </h1>
          <p className="text-white/80 max-w-xl leading-relaxed">
            Comprehensive roofing, masonry, and exterior solutions for residential and commercial properties throughout Chicagoland — backed by 35+ years of expertise.
          </p>
        </div>
      </section>

      {/* Trust bar */}
      <section className="bg-brand-dark py-5 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-wrap items-center justify-center gap-6 lg:gap-10">
          {['Licensed & Insured', 'Family-Owned Since 1989', 'Residential & Commercial', 'Free Written Estimates'].map((badge) => (
            <span key={badge} className="flex items-center gap-1.5 text-xs text-gray-400 whitespace-nowrap">
              <i className="ri-shield-check-fill text-brand-gold text-xs" />
              {badge}
            </span>
          ))}
        </div>
      </section>

      {/* Services by category */}
      <section className="bg-brand-cream py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {categories.map((cat) => {
            const catServices = services.filter((s) => s.category === cat.key);
            return (
              <div key={cat.key} className="mb-16">
                <div className="flex items-center gap-3 mb-8">
                  <div className="h-px bg-brand-cream-3 flex-1" />
                  <h2 className="font-display text-2xl font-bold text-brand-dark px-4">{cat.label}</h2>
                  <div className="h-px bg-brand-cream-3 flex-1" />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {catServices.map((service) => (
                    <Link
                      key={service.id}
                      to={`/services/${service.slug}`}
                      className="group bg-white rounded-lg overflow-hidden border border-brand-cream-3 hover:border-brand-gold transition-all duration-300 cursor-pointer"
                    >
                      <div className="w-full h-48 overflow-hidden">
                        <img src={service.image} alt={service.name} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                      </div>
                      <div className="p-6">
                        <div className="flex items-center gap-2 mb-3">
                          <div className="w-8 h-8 flex items-center justify-center bg-brand-green/10 rounded-md">
                            <i className={`${service.icon} text-brand-green text-sm`} />
                          </div>
                          <h3 className="font-semibold text-brand-dark text-base">{service.name}</h3>
                        </div>
                        <p className="text-sm text-gray-500 leading-relaxed mb-4">{service.longDesc}</p>
                        <div className="flex flex-wrap gap-1.5 mb-4">
                          {service.features.slice(0, 4).map((f) => (
                            <span key={f} className="text-xs bg-brand-cream px-2.5 py-1 rounded-full text-gray-600">{f}</span>
                          ))}
                          {service.features.length > 4 && (
                            <span className="text-xs text-brand-green font-medium px-2">+{service.features.length - 4} more</span>
                          )}
                        </div>
                        <span className="text-sm font-bold text-brand-green flex items-center gap-1 group-hover:gap-2 transition-all">
                          Get Free Estimate <i className="ri-arrow-right-line text-sm" />
                        </span>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="bg-brand-green py-14">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-display text-3xl font-bold text-white mb-3">Not Sure Which Service You Need?</h2>
          <p className="text-white/80 mb-7">We conduct a free, thorough inspection and tell you exactly what needs attention — no upselling, no pressure.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/contact" className="bg-brand-gold hover:bg-brand-gold-dark text-white text-sm font-bold px-8 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap">
              Schedule Free Inspection
            </Link>
            <a href="tel:7086984072" className="border-2 border-white/40 hover:border-white text-white text-sm font-bold px-8 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2">
              <i className="ri-phone-fill" />
              (708) 698-4072
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
